export default "__VITE_ASSET__ClnlF6qw__"